import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {EditorModule} from '@tinymce/tinymce-angular';

import {TinymceInputComponent} from './tinymce-input.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TranslateModule,
        EditorModule
    ],
    declarations: [
        TinymceInputComponent
    ],
    exports: [
        TinymceInputComponent
    ]
})
export class TinymceInputModule {}